const menu = [
	{
		heading: 'MENU',
	},
	{
		name: 'Escritorio',
		path: '/home',
		icon: 'ri-home-8-line',
		permission: 'home-index',
	},
	{
		name: 'Requerimientos',
		icon: 'fas fa-book-reader',
		permissions: ['home-index'],
		submenu: [
			{
				name: 'Nuevo',
				path: '/administrator/requirements/create',
				permission: 'home-index',
			},
			{
				name: 'Historial',
				path: '/administrator/requirements/index',
				permission: 'home-index',
			},
		],
	},
	/** CAMBIAR CONTRASEÑA */
	{
		name: 'Cambiar contraseña',
		path: '/change-password',
		icon: 'ri-lock-line',
		permission: 'home-index',
	},
];

export default menu;
